// extracted by mini-css-extract-plugin
export default {"tableWrapper":"MissionList_tableWrapper__-BqTP","disableBorder":"MissionList_disableBorder__KiwNA","menuItemIcon":"MissionList_menuItemIcon__rLs5C"};